// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoSection_infoSection__rEjJx{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 30px;
    border-bottom: 1px solid #1F363D1A;
}
.InfoSection_hasImages__jIpPS{
    border-bottom: none;
}
@media(max-width: 600px){
    .InfoSection_infoSection__rEjJx{
        padding-bottom: 20px;
    }
}
.InfoSection_leftSide__\\+1OMK{
    display: flex;
    width: calc(100% - 200px);
}
.InfoSection_organizer__KYEBw, .InfoSection_organization__ICr0Y{
    display: flex;
    align-items: center;
}
.InfoSection_organizerPicture__WNaLp, .InfoSection_organizationPicture__11\\+t2{
    height: 41px;
    width: 41px;
    margin-right: 10px;
    border-radius: 50%;
    object-fit: cover;
}
.InfoSection_imagePlaceholder__4T8K9{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-basis: 41px;
    flex-grow: 0;
    flex-shrink: 0;
    height: 41px;
    width: 41px;
    margin-right: 10px;
    color: #578E86;
    background-color: #BFE1DC;
    font-size: 16px;
    font-family: 'Gotham Medium', serif;
    border-radius: 50%;
    letter-spacing: -3px;
}
.InfoSection_organizerName__7oRgk, .InfoSection_organizationName__Vy2r\\+{
    color: #1F363D;
    font-size: 16px;
    font-family: 'Gotham Medium', serif;
}
@media(max-width: 600px){
    .InfoSection_organizerPicture__WNaLp, .InfoSection_organizationPicture__11\\+t2{
        height: 31px;
        width: 31px;
    }
    .InfoSection_imagePlaceholder__4T8K9{
        flex-basis: 31px;
        height: 31px;
        width: 31px;
        font-size: 12px;
        letter-spacing: -1.5px;
    }
    .InfoSection_organizerName__7oRgk, .InfoSection_organizationName__Vy2r\\+{
        font-size: 14px;
    }
}
.InfoSection_organizerName__7oRgk{
    margin-right: 10px;
}
.InfoSection_organizationName__Vy2r\\+{
    margin-right: 50px;
}
.InfoSection_viaText__fy35O{
    margin-right: 10px;
    color: #1F363D;
    font-size: 16px;
    opacity: 60%;
}
.InfoSection_organizationLinkContainer__5YdWP{
    display: flex;
    align-items: center;
    text-decoration: none;
}
.InfoSection_organizationLocation__knt37{
    display: flex;
    align-items: center;
    color: #1F363D;
    font-size: 14px;
}
.InfoSection_locationPin__SahoI{
    height: 20px;
    width: 14px;
    margin-right: 10px;
}
.InfoSection_startEndText__Jz\\+l0{
    margin-left: auto;
    padding-left: 50px;
    color: #1F363D;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
}
@media(min-width: 1081px) and (max-width: 1280px), (max-width: 800px){
    .InfoSection_leftSide__\\+1OMK{
        display: flex;
        flex-wrap: wrap;
        width: 100%;
    }
    .InfoSection_organizationName__Vy2r\\+{
        margin-right: 25px;
    }
    .InfoSection_organizationLocation__knt37{
        margin-left: auto;
    }
    .InfoSection_startEndText__Jz\\+l0{
        width: 100%;
        margin-top: 20px;
        margin-left: 0;
        padding-left: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/fundraiser/InfoSection.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,kCAAkC;AACtC;AACA;IACI,mBAAmB;AACvB;AACA;IACI;QACI,oBAAoB;IACxB;AACJ;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,mCAAmC;IACnC,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,gBAAgB;QAChB,YAAY;QACZ,WAAW;QACX,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI;QACI,aAAa;QACb,eAAe;QACf,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,cAAc;QACd,eAAe;IACnB;AACJ","sourcesContent":[".infoSection{\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    padding-bottom: 30px;\n    border-bottom: 1px solid #1F363D1A;\n}\n.hasImages{\n    border-bottom: none;\n}\n@media(max-width: 600px){\n    .infoSection{\n        padding-bottom: 20px;\n    }\n}\n.leftSide{\n    display: flex;\n    width: calc(100% - 200px);\n}\n.organizer, .organization{\n    display: flex;\n    align-items: center;\n}\n.organizerPicture, .organizationPicture{\n    height: 41px;\n    width: 41px;\n    margin-right: 10px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n.imagePlaceholder{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-basis: 41px;\n    flex-grow: 0;\n    flex-shrink: 0;\n    height: 41px;\n    width: 41px;\n    margin-right: 10px;\n    color: #578E86;\n    background-color: #BFE1DC;\n    font-size: 16px;\n    font-family: 'Gotham Medium', serif;\n    border-radius: 50%;\n    letter-spacing: -3px;\n}\n.organizerName, .organizationName{\n    color: #1F363D;\n    font-size: 16px;\n    font-family: 'Gotham Medium', serif;\n}\n@media(max-width: 600px){\n    .organizerPicture, .organizationPicture{\n        height: 31px;\n        width: 31px;\n    }\n    .imagePlaceholder{\n        flex-basis: 31px;\n        height: 31px;\n        width: 31px;\n        font-size: 12px;\n        letter-spacing: -1.5px;\n    }\n    .organizerName, .organizationName{\n        font-size: 14px;\n    }\n}\n.organizerName{\n    margin-right: 10px;\n}\n.organizationName{\n    margin-right: 50px;\n}\n.viaText{\n    margin-right: 10px;\n    color: #1F363D;\n    font-size: 16px;\n    opacity: 60%;\n}\n.organizationLinkContainer{\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n}\n.organizationLocation{\n    display: flex;\n    align-items: center;\n    color: #1F363D;\n    font-size: 14px;\n}\n.locationPin{\n    height: 20px;\n    width: 14px;\n    margin-right: 10px;\n}\n.startEndText{\n    margin-left: auto;\n    padding-left: 50px;\n    color: #1F363D;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n}\n@media(min-width: 1081px) and (max-width: 1280px), (max-width: 800px){\n    .leftSide{\n        display: flex;\n        flex-wrap: wrap;\n        width: 100%;\n    }\n    .organizationName{\n        margin-right: 25px;\n    }\n    .organizationLocation{\n        margin-left: auto;\n    }\n    .startEndText{\n        width: 100%;\n        margin-top: 20px;\n        margin-left: 0;\n        padding-left: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoSection": `InfoSection_infoSection__rEjJx`,
	"hasImages": `InfoSection_hasImages__jIpPS`,
	"leftSide": `InfoSection_leftSide__+1OMK`,
	"organizer": `InfoSection_organizer__KYEBw`,
	"organization": `InfoSection_organization__ICr0Y`,
	"organizerPicture": `InfoSection_organizerPicture__WNaLp`,
	"organizationPicture": `InfoSection_organizationPicture__11+t2`,
	"imagePlaceholder": `InfoSection_imagePlaceholder__4T8K9`,
	"organizerName": `InfoSection_organizerName__7oRgk`,
	"organizationName": `InfoSection_organizationName__Vy2r+`,
	"viaText": `InfoSection_viaText__fy35O`,
	"organizationLinkContainer": `InfoSection_organizationLinkContainer__5YdWP`,
	"organizationLocation": `InfoSection_organizationLocation__knt37`,
	"locationPin": `InfoSection_locationPin__SahoI`,
	"startEndText": `InfoSection_startEndText__Jz+l0`
};
export default ___CSS_LOADER_EXPORT___;
